export const sizes = [
  "Small",
  "Medium",
  "Large",
  "Enterprise",
];
